<a #topOfPage id="topOfPage"></a>
<form id="applicantTypeForm" [formGroup]="applicantTypeForm" #formDirective="ngForm" (ngSubmit)="onSubmit()">

  @if (isMobile) {
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  } @else {
    <prism-ui-page-content
    key-id="page-content"
    custom-max-width="680"
    >  
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </prism-ui-page-content>
  }
</form>

<ng-template #contentTemplate>
  <div class="page-content" page-content>
    <prism-ui-heading 
      font-size="lg" 
      font-weight="regular" 
      key-id="applicant-type-title" 
      is-uppercase="false"
      variant="default"
      >{{pageTitle}}
    </prism-ui-heading>

    <form id="applicantTypeForm" [formGroup]="applicantTypeForm" #formDirective="ngForm" (ngSubmit)="onSubmit()" class="form-inline">

        <div class="row">
          <div class="alignTooltips">
            <prism-ui-label
              font-size="md"
              font-weight="strong"
              key-id="applicant-type-label"
              label-for="eeoi-tooltip-wizard-applicant"
              line-height="medium"
              text-transform="none"
              variant="default"
            >

        {{ applicantTypeElement?.label }}
            </prism-ui-label>

            <div class="toolTipLeftPadding">
              <prism-ui-icon-button
                expanded="false"
                has-tooltip="true"
                icon-name="circle-info"
                is-inactive="false"
                is-waiting="false"
                key-id="eeoi-tooltip-wizard-applicant"
                label="{{applicantToolTipText}}"
                size="small"
                [tooltipPosition]="applicantToolTipPosition"
                type="button"
                variant="tertiary"
              >
                <div class="applicantToolTipWidth applicantToolTipPadding">
                  <prism-ui-copy key-id="coverageTooltip">{{applicantToolTipText}}</prism-ui-copy>
                </div>
              </prism-ui-icon-button>
            </div>

          </div>
        </div>
        <div class="paddingBottom">
          <prism-ui-form-field-select
            [isValid]="!showError"
            [form-field-items-count]="applicantTypes.length"
            key-id="applicantTypeCheckboxGroup"
            orientation="vertical"
          >
            <span slot="error">{{ applicantTypeElement.error }}</span>

          </prism-ui-form-field-select>

          <div class="checkbox-group">
          @for (appType of applicantTypes; track appType; let index = $index) {
           <prism-ui-container
              is-compact="false"
              key-id="app-type-container-{{ index }}"
              has-shadow="false"
              variant="default"
              has-no-border-radius="false"
            >
              <div id="applicantType-{{ index }}" formArrayName="applicantTypes" >
                  <prism-ui-checkbox
                    labelText="{{appType.label}}"
                    [keyId]="appType.abbreviation"
                    ngDefaultControl
                    [name]="appType.abbreviation"
                    formControlName="{{ index }}"
                    [checked]="applicantTypeForm.get('applicantTypes')?.value[index]"
                    [isValid]="!showError"
                    (prismUiCheckboxOnChange)="logCheckboxChangeEvent($event, index)"
                  >
                  </prism-ui-checkbox>
                </div>
          
          <!-- Child count select dropdown - shown when child checkbox is selected -->
          @if (showChildCountSelect && appType.abbreviation === 'child') {
            <div class="child-count-container">
              <prism-ui-form-field
                [isValid]="true"
                key-id="childCount"
              >
                <span slot="label">{{applicantTypeElementChild?.label}}</span>
                <prism-ui-select
                  slot="input"
                  key-id="childCountSelect"
                  has-placeholder="false"
                  is-required="true"
                  [isValid]="true"
                  [options]="childCountOptions"
                  [selectedValue]="applicantTypeForm.get('childCount')?.value?.toString()"
                  ngDefaultControl
                  [formGroup]="applicantTypeForm"
                  formControlName="childCount"
                  (selectEvent)="handleChildCountChange($event)"
                >
                </prism-ui-select>
              </prism-ui-form-field>
            </div>
          }
              </prism-ui-container>
            }
          </div>

      </div>

      

      <div class="row continueCancelButtonPadding">
        <app-continue-cancel (cancelEmitter)="onCancel()"></app-continue-cancel>
      </div>
    </form>
  </div>
</ng-template>

<prism-ui-modal key-id="cancel-modal" has-dark-overlay="true">
  <prism-ui-heading
    slot="modal-header"
    key-id="cancel-modal"
    font-size="sm"
    font-weight="strong"
  >{{modalContentHeading}}</prism-ui-heading
  >
  <prism-ui-copy
    slot="modal-body"
    key-id="cancel-modal"
  >
    {{modalContentBody}}
  </prism-ui-copy>
  <div slot="modal-footer">
    <div class="modalButtonStyling">
      <prism-ui-button
        button-width="full"
        key-id="cancel-button"
        size="md"
        variant="secondary"
        type="button"
        is-icon-right-aligned="false"
        (click)="onCancelModal('prism-ui-modal-cancel-modal')"
      >Cancel</prism-ui-button>
      <prism-ui-button class="leftPaddingSmall"
        button-width="full"
        key-id="continue-button"
        size="md"
        variant="primary"
        type="button"
        is-icon-right-aligned="false"
        (click)="leaveAnyway()"
      >Leave Anyway</prism-ui-button>
    </div>
</div>
</prism-ui-modal>
